import $ from 'jquery'

class Demo {
  static myMove(top, left, t, time, delay) {
    // let t = $(target).offset()
    $('#cursor').animate({
      'top': t.top  + top + 'px',
      'left': t.left  + left + 'px',
      }, time
    ).delay(delay)
  }
  static ScrollWindow(offset) {
    const windowWidth = $(window).width()
    const windowHeight = $(window).height()
    if (windowWidth < 768 || windowHeight < 650) {
      $("html, body").animate({ scrollTop: offset }, 500)
    }
  }
  static ResetCursor() {
    const windowWidth = $(window).width()
    $('#cursor').animate({
      'top': 370 + 'px',
      'left': windowWidth/2 - 150 + 'px',
      }, 0
    ).delay(300)
  }
  static delay(fn, t) {
    var queue = [], self, timer;
    
    function schedule(fn, t) {
      timer = setTimeout(function() {
        timer = null;
        fn();
        if (queue.length) {
          var item = queue.shift();
          schedule(item.fn, item.t);
        }
      }, t);            
    }
    self = {
      delay: function(fn, t) {
        if (queue.length || timer) {
          queue.push({fn: fn, t: t});
        } else {
          schedule(fn, t);
        }
        return self;
      },
      cancel: function() {
        clearTimeout(timer);
        queue = [];
        return self;
      }
    };
    return self.delay(fn, t);
  }
  static setHighliteOffset(t, highliteMargin, task_2) {
    $(".highlight-inner-button")
      .css({"top": t.top - 17, 
            "left": t.left - highliteMargin + task_2})
  }
}

export default Demo